module.exports = __webpack_public_path__ + "img/banji.5eac9119.png";